import React from 'react';
import PropTypes from 'prop-types';

export const FormField = ({label, required, children, style, hidden}) => {
  const hd = hidden !== undefined ? hidden : false;

  return (
    <div style={style||{}} className={`form-field ${!hd ? '' : 'form-field-hidden'}`}>
      <label className='label'>{label}{required ? <sup style={{color: 'red'}}>*</sup>:null}</label>
      {children}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  hidden: PropTypes.bool,
};
